const session = {
    expiredDueToInactivity: '操作がなかったため、セッションの有効期限が切れました。',
    expiresSoon: '操作がないため、あと5分でセッションの有効期限が切れます。',
    expired: 'セッションの有効期限が切れました。再度ログインしてください。',
    extended: 'セッションを延長しました。',
    staySignedIn: 'サインインを継続',
  };

export default session;
